import { Box } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const Container = styled(Box)`
  ${() => css`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    margin-top: 24px;
  `}
`

export const ArrowButton = styled.button<{ disabled?: boolean }>`
  ${({ theme, disabled }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border: 1px solid ${theme.colors.primary};
    border-radius: 6px;
    background: ${theme.colors.lightest};
    cursor: ${disabled ? 'not-allowed' : 'pointer'};
    transition: all 0.2s ease;
    color: ${theme.colors.primary};
    opacity: ${disabled ? 0.5 : 1};

    &:hover:not(:disabled) {
      background: ${theme.colors.primary};
      color: ${theme.colors.lightest};
    }

    &:disabled {
      cursor: not-allowed;
    }

    svg {
      width: 16px;
      height: 16px;
    }
  `}
`

export const BulletsContainer = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const Bullet = styled.button<{ active?: boolean }>`
  ${({ theme, active }) => css`
    width: 8px;
    height: 8px;
    border-radius: 50%;
    border: none;
    background: ${active ? theme.colors.primary : theme.colors.border.light};
    cursor: pointer;
    transition: all 0.2s ease;
    padding: 0;

    &:hover {
      background: ${active ? theme.colors.primary : theme.colors.gray.dark};
      transform: scale(1.2);
    }
  `}
`
